'use client';

import { useEffect, useState } from 'react';

const END_DATE = new Date('2027-01-06T00:00:00Z').getTime();

export function LaunchCountdown() {
	const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
		const interval = setInterval(() => {
			const now = new Date().getTime();
			const distance = END_DATE - now;

			if (distance < 0) {
				clearInterval(interval);
				return;
			}

			setTimeLeft({
				days: Math.floor(distance / (1000 * 60 * 60 * 24)),
				hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
				minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
				seconds: Math.floor((distance % (1000 * 60)) / 1000),
			});
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	if (!isMounted) return null;

	const { days, hours } = timeLeft;
	const months = Math.floor(days / 30);
	const remainingDays = days % 30;

	return (
		<div className="flex items-center justify-center my-6">
			<div className="bg-slate-900 text-white rounded-xl px-6 py-4 shadow-sm inline-block">
				<span className="text-xl sm:text-2xl font-black tracking-wide">
					{months > 0 && `${months} month${months !== 1 ? 's' : ''}, `}
					{remainingDays} day{remainingDays !== 1 ? 's' : ''}, {hours} hour{hours !== 1 ? 's' : ''}
				</span>
			</div>
		</div>
	);
}
